import React, {useEffect, useRef, useState} from 'react';
import './contact.css';
import {MdOutlineMailOutline} from 'react-icons/md';
import {FaTelegramPlane} from 'react-icons/fa';
import {BsInstagram} from 'react-icons/bs';
import { FiArrowUpRight } from "react-icons/fi";
import emailjs from 'emailjs-com';
import Filter from 'bad-words';
import Aos from "aos";
import 'aos/dist/aos.css';

const Contact = ({observer}) => {
    const sectionRef = useRef(null);
    const formRef = useRef(null);

    const [sending, setSending] = useState(false);
    const [status, setStatus] = useState({ok: false, msg: ""});

    const filter = new Filter();
    filter.addWords('suck', 'silly', 'dumb');

    useEffect(() => {
        Aos.init({duration: 1500});
    }, [])

    useEffect(() => {
        if (observer) {
            observer.observe(sectionRef.current);
        }
    }, [sectionRef, observer])

    const sendEmail = (e) => {
        e.preventDefault();
        setStatus({ok: false, msg: ""});

        // Honeypot anti-spam: hidden field must remain empty
        if (e.target.website.value) return;

        if (e.target.message.value.length < 20) {
            setStatus({ ok: false, msg: "Please add some project details." });
            return;
        }

        if (!filter.isProfane(e.target.message.value)) {
            setSending(true);
            console.log('ok to send');
            emailjs.sendForm('service_psabp8k', 'template_bdps3l3', formRef.current, 'DjbuLLSBCv_PY31x9')
                .then((result) => {
                    console.log(result.text);
                    setStatus({ok: true, msg: "Thanks! Your message has been sent."});
                    e.target.reset();
                    // alert("Your message is successfully sent! Thank you!");
                }, (error) => {
                    console.log(error.text);
                    setStatus({ ok: false, msg: "Oops, something went wrong. Please try again or use Instagram/Telegram." });
                    // alert(error.text);
                })
                .finally(() => {
                    setSending(false);
                });
        } else {
            setStatus({ ok: false, msg: "Oops! Your message contains inappropriate language. Please rephrase politely." });
        }
    };

    return (
        <section id='contact' ref={sectionRef}>
            <div data-aos='fade-up' data-aos-duration='2000' className='contact_header'>
                <h2 className="eyebrow">Get in touch</h2>
                <h1>Let's discuss your project</h1>
                <p>Share your idea, plans and preferred timeline. I’ll reply with the next steps, estimated cost and anything else needed to begin.</p>
            </div>
            <div data-aos='zoom-in' data-aos-duration='2000' className='container contact_container'>
                <div className="contact_cards" aria-label="Quick contact options">
                    <a href="mailto:artdesignyana@gmail.com" className="contact_card" target="_blank" rel="noreferrer">
                        <MdOutlineMailOutline className="contact_icon" />
                        <div>
                            <h3>Email</h3>
                            <p>For detailed briefs and project files</p>
                            <span className="contact_detail">artdesignyana@gmail.com</span>
                        </div>
                        <FiArrowUpRight className="contact_action" />
                    </a>

                    <a href="https://telegram.me/artdesign_yana" className="contact_card" target="_blank" rel="noreferrer">
                        <FaTelegramPlane className="contact_icon" />
                        <div>
                            <h3>Telegram</h3>
                            <p>For quick questions and project updates</p>
                            <span className="contact_detail">@artdesign_yana</span>
                        </div>
                        <FiArrowUpRight className="contact_action" />
                    </a>

                    <a href="https://instagram.com/artdesign_yana" className="contact_card" target="_blank" rel="noreferrer">
                        <BsInstagram className="contact_icon" />
                        <div>
                            <h3>Instagram</h3>
                            <p>Explore recent work and visual inspiration</p>
                            <span className="contact_detail">@artdesign_yana</span>
                        </div>
                        <FiArrowUpRight className="contact_action" />
                    </a>
                </div>

                <form ref={formRef} onSubmit={sendEmail} className="contact_form">
                    <div className="form_row">
                        <div className="form_field">
                            <label htmlFor="name">Full name</label>
                            <input id="name" name="name" type="text" placeholder="Your name" required />
                        </div>
                        <div className="form_field">
                            <label htmlFor="email">Email</label>
                            <input id="email" name="email" type="email" placeholder="your@email.com" required />
                        </div>
                    </div>

                    <div className="form_row">
                        <div className="form_field">
                            <label htmlFor="service">Service</label>
                            <select id="service" name="service" defaultValue="">
                                <option value="" disabled>Select a service</option>
                                <option>Interior sketch</option>
                                <option>Exterior sketch</option>
                                <option>2D colored floor plan</option>
                                <option>3D plan / axonometric</option>
                                <option>Landscape sketch</option>
                                <option>Other</option>
                            </select>
                        </div>
                        <div className="form_field">
                            <label htmlFor="timeline">Timeline</label>
                            <select id="timeline" name="timeline" defaultValue="">
                                <option value="" disabled>Select a timeline</option>
                                <option>ASAP (1–3 days)</option>
                                <option>Within 1 week</option>
                                <option>1–2 weeks</option>
                                <option>2–4 weeks</option>
                                <option>Flexible / not sure</option>
                            </select>
                        </div>
                    </div>

                    <div className="form_field">
                        <label htmlFor="message">Project details</label>
                        <textarea id="message" name="message" rows="9" placeholder="Tell me about the space, required views, style and available plans…" required />
                    </div>

                    {/* Honeypot */}
                    <input type="text" name="website" tabIndex="-1" autoComplete="off" className="hp_field" />

                    <div className="form_actions">
                        <button type="submit" className="btn btn-primary" disabled={sending}>
                            {sending ? "Sending…" : "Send message"}
                        </button>
                        <span className="form_hint">For a precise estimate, include the number of views and your deadline.</span>
                    </div>
                    <div className={`form_status ${status.ok ? "ok" : status.msg ? "err" : ""}`} aria-live="polite">
                        {status.msg}
                    </div>
                </form>
            </div>
        </section>
    );
};

export default Contact;
